import React from 'react'
import { HowToBook } from '@/commons/service-hub/HowToBook'
import { airconBookingSteps } from 'data/service-hub-content'

// Aircon preset of the shared HowToBook section (hub, chemical wash, urgent).
export const HowToBookAirconService = () => (
    <HowToBook theme="light" title="How to Book Aircon Service" steps={airconBookingSteps} />
)
